export default class StatePrice {
  constructor(statePrices) {
    this._handlePostcodeChanged = this._handlePostcodeChanged.bind(this);
    this._showStatePrice = this._showStatePrice.bind(this);

    this.defaultPriceElm = document.querySelector("[data-default-price-value]");
    this.defaultPrice = this.defaultPriceElm.getAttribute("data-default-price-value");
    this.elementToShowPrices = document.querySelectorAll("[data-state-price-display]");

    this.stateInfoUrl = $(".details-price").data("state-info-url");
    this.statePrices = statePrices;
  }

  init() {
    if(this.statePrices.length === 0) return;
    // event should be fired as follow:
    // window.dispatchEvent(new CustomEvent("Postcode.Changed", {detail : {postcode: xxxx }}));
    window.addEventListener("Postcode.Changed", this._handlePostcodeChanged);
  }

  _handlePostcodeChanged(eventData) {
    if (this._isValidPostcode(eventData.detail.postcode) && eventData.detail.postcode!=="") {
      this._fetchStateInfoForPostcode(eventData.detail.postcode);
    }
    else if (eventData.detail.postcode === "") {
      this._showStatePrice("default");
    }
  }

  _fetchStateInfoForPostcode(postcode) {
    fetch(`${this.stateInfoUrl}?postcode=${postcode}`)
      .then(res => {
        if (!res.ok) {
          return res.json().then(result => {
            throw Error(result.error)
          });
        }
        return res.json();
      })
      .then(result => {
        this._showStatePrice(result.stateAbbr.toLowerCase());
      })
      .catch(error => {
        console.log(error.message);

        this._showStatePrice("default");
      });
  }

  _showStatePrice(stateAbbr) {
    let statePriceSearch = this.statePrices.filter(statePrice => statePrice.state.toLowerCase() === stateAbbr.toLowerCase());
    let statePrice = this.defaultPrice;
    if (statePriceSearch.length > 0) {
      statePrice = statePriceSearch[0].price;
    }
    if (this.elementToShowPrices.length > 0) {
      for (let i = 0; i < this.elementToShowPrices.length; i++) {
        this.elementToShowPrices[i].innerHTML = statePrice;
      }
    }
  }

  _isValidPostcode(postcode) {
    const australianPostcodeRegex = /^((0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2}))*$/;
    return australianPostcodeRegex.test(postcode);
  }
}